module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Cooking/Fork-spoon-knife-89530f47a207817fb5dc75578e9f0714.svg";